import * as React from 'react';
import Visibility from '@mui/icons-material/VisibilityRounded';
import VisibilityOff from '@mui/icons-material/VisibilityOffRounded';
import {Input} from './Input';

export const PasswordInput: React.FC<
  React.ComponentProps<typeof Input>
> = props => {
  const passwordRef = React.useRef<HTMLInputElement>(null);
  const [hidePassword, setHidePassword] = React.useState(true);
  const togglePassword = () => {
    setHidePassword(!hidePassword);
    if (passwordRef && passwordRef.current) {
      passwordRef.current.focus();
    }
  };
  return (
    <Input
      {...props}
      innerRef={passwordRef}
      type={hidePassword ? 'password' : 'text'}
      icon={hidePassword ? VisibilityOff : Visibility}
      iconClick={togglePassword}
    />
  );
};

PasswordInput.defaultProps = {
  label: 'Password',
};
